var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9723 10.3289H19.9989V4L17.5723 6.49778C14.4523 3.41333 9.44781 3.41333 6.32781 6.49778C3.20781 9.58222 3.23447 14.5956 6.34559 17.68C9.46559 20.7733 14.5323 20.7733 17.6523 17.68C19.2167 16.1333 19.9989 13.8489 19.9989 12.0889H18.2211C18.2211 13.8489 17.6167 15.2444 16.4078 16.4356C13.9811 18.8444 10.0523 18.8444 7.62559 16.4356C5.19892 14.0267 5.19892 10.1422 7.62559 7.73333C10.0523 5.33333 13.9811 5.42222 16.4078 7.82222L13.9723 10.3289ZM12.4434 12.2222V8.44444H11.11V12.8889L14.9145 15.1467L15.5545 14.0711L12.4434 12.2222Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.081b6bf1beee57605a9950394831937d.svg";
export { ForwardRef as ReactComponent };